import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'Skeleton' }

import { computed } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  /**
     * Maximum width for random size
     */
  maxWidth: {
    default: 100,
    type: Number
  },
  /**
     * Minimum width for random size
     */
  minWidth: {
    default: 80,
    type: Number
  },
  /**
     * Skeletonheight
     */
  height: {
    default: '1rem',
    type: String
  },
  /**
     * Static width
     */
  width: {
    default: null,
    type: String
  },
  /**
     * Element completely round
     */
  round: {
    type: Boolean,
    default: false
  },
  /**
     * Use the full container
     */
  fullSize: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



const computedWidth = computed(() => {
  return props.width || `${Math.floor((Math.random() * (props.maxWidth - props.minWidth)) + props.minWidth)}%`
})

return { __sfc: true,props, computedWidth }
}

})